import EcoImg from 'eco-design/base/eco-img';
import { AnimatedGrid } from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const Automotive2: React.FC = () => {
    const { t } = useLang('Automotive2');
    return (
        <div className={`${styles.Automotive2} GtmModuleData-section`} data-section-id="d3c-Automotive2">
            <EcoImg
                className="bg"
                isOpenLazy={true}
                pc="https://websiteoss.ecoflow.com/upload/image/1774857696267/PC-2.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1774857696908/M-2.jpg"
            />
            <div className="d3m-layout ">
                <div className="text-wrapper">
                    <CommonTitle title={t('title')} desc={t.rich('desc', { sup: (text: string) => <sup>{text}</sup> })} />
                    <AnimatedGrid variant="rotateIn" options={{ delay: 400, stagger: 0.15, threshold: 0.2 }} className="list-wrapper">
                        <div className="list-item">
                            <div className="list-item-title">{t('list1_title')}</div>
                            {/* <div className="list-item-desc">{t('list1_desc')}</div> */}
                        </div>
                        <div className="list-item">
                            <div className="list-item-title">{t('list2_title')}</div>
                            <div className="list-item-desc">{t('list2_desc')}</div>
                        </div>
                    </AnimatedGrid>
                </div>
            </div>
        </div>
    );
};

export default Automotive2;
